<template>
<span>
  <a class="data-table-action"
     v-if="object.imageUrl && ['new', 'initiated'].includes(object.status)"
     :title="$t('upload')"
     v-b-tooltip.hover
     @click="upload">
    <MailSvg class="svg-light svg-size-lg"/>
    <span class="action-button-mob-title">{{ $t('upload') }}</span>
  </a>
  <a class="data-table-action"
     v-if="['uploaded'].includes(object.status)"
     :title="$t('see_in_vendor', { vendor: 'Diagnocat' })"
     v-b-tooltip.hover
     @click="openInDiagnocat('webpage')">
    <EyeSvg class="svg-light svg-size-lg"/>
    <span class="action-button-mob-title">{{ $t('see_in_vendor', { vendor: 'Diagnocat' }) }}</span>
  </a>
   <a class="data-table-action"
      v-if="['uploaded'].includes(object.status)"
      :title="$t('pdf_report')"
      v-b-tooltip.hover
      @click="openInDiagnocat('pdf')">
    <FilePdfSvg class="svg-light svg-size-lg"/>
    <span class="action-button-mob-title">{{ $t('pdf_report') }}</span>
  </a>
    </span>
</template>

<script setup>
import MailSvg from '@/assets/svg-vue/marketing/mail_forward.svg'
import EyeSvg from '@/assets/svg-vue/form/eye.svg'
import FilePdfSvg from '@/assets/svg-vue/patients/file_pdf.svg'
import { AIPhotoStudyService } from "@/services/api/ai-photo-study.api.service"
import { useStore } from "vuex"

const store = useStore()

const props = defineProps({
  object: {
    type: Object
  }
})

const upload = async () => {
  try {
    const res = await AIPhotoStudyService.uploadToDiagnocat(props.object.patient_id, props.object.id)
    if(res.data) {
      store.commit('incrementDataTableCounter')
    }
  } catch (e) {
    console.log(e)
  }
}

const openInDiagnocat = async (type) => {
  try {
    const res = await AIPhotoStudyService.getDiagnocatLink(props.object.patient_id, props.object.id, type)
    if(res.data) {
      window.open(res.data, '_blank')
    }
  } catch (e) {
    console.log(e)
  }
}
</script>
